import { render } from "./BaseList.vue?vue&type=template&id=56517e36&scoped=true&ts=true"
import script from "./BaseList.vue?vue&type=script&lang=ts"
export * from "./BaseList.vue?vue&type=script&lang=ts"

import "./BaseList.vue?vue&type=style&index=0&id=56517e36&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56517e36"]])

export default __exports__